module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 bg-lightest border-light card-height-2 d-flex flex-column radius-normal"
  }, [_c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "text-center darker font-weight-600 my-4 fs-large"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dark text-center fs-small"
  }, [_vm._v("\n            " + _vm._s(_vm.subTitle) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center w-100 mb-5 infoHolder"
  }, [_c('graph', {
    staticClass: "graph w-100",
    attrs: {
      "height": 230,
      "chartData": _vm.graphData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-095acd0e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/cardGraphSummary.vue
// module id = 2569
// module chunks = 0